import type { Logger } from "@expert/logging";

import { useGuideStore } from "./useGuideStore";

export const setRecommendation = (logger: Logger, recommendation?: string) => {
    useGuideStore.getState().setRecommendation(recommendation);
    logger.info({ recommendation }, "Solve Guide | Guided flow recommendation set");
};
